<template>
  <div>
    <md-tabs md-alignment="centered">
      <md-tab md-label="Aktivne" v-on:click="filter = ['online_sold', 'offline_sold', 'reservation']"/>
      <md-tab md-label="U čekanju" v-on:click="filter = ['online_checkout', 'offline_checkout']"/>
      <md-tab md-label="Stornirano" v-on:click="filter = ['cancelled', 'aborted']"/>
      <md-tab md-label="Sve" v-on:click="filter = ['all']"/>
    </md-tabs>
    <p class="error-message" style="color: red;text-align: center;font-weight: bold;">
      <span v-for="error in $store.state.errors">
        {{ error }}<br>
      </span>
    </p>
    <md-table>
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <h1 class="md-title">Transakcije</h1>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>ID</md-table-head>
        <md-table-head>Kupon</md-table-head>
        <md-table-head>Količina</md-table-head>
        <md-table-head>Datum plaćanja</md-table-head>
        <md-table-head>Vrsta plaćanja</md-table-head>
        <md-table-head>Broj rata</md-table-head>
        <md-table-head>Cijena</md-table-head>
        <md-table-head>Akcije</md-table-head>
      </md-table-row>
      <md-table-row v-for="item in filteredTransactions" v-if="!item.status != 'aborted'">
        <md-table-cell md-numeric>{{ item.id }}</md-table-cell>
        <md-table-cell>{{ item.data.coupon_title }}</md-table-cell>
        <md-table-cell>{{ item.data.count }}</md-table-cell>
        <md-table-cell>{{ item.payment_date }}</md-table-cell>
        <md-table-cell class="capitalize">{{ getPaymentType(item.payment_type) }}<span v-if="item.payment_type == 'card'">/{{ item.card_type }}</span></md-table-cell>
        <md-table-cell>{{ item.installments }}</md-table-cell>
        <md-table-cell>{{ formatCurrency(item.amount) }}</md-table-cell>
        <md-table-cell>
          <md-button class="md-raised md-dense md-accent" :disabled="isCancelDisabled(item)" v-on:click="$store.state.currentTransaction = JSON.parse(JSON.stringify(item)); cancelDialog = true;">
            Storno
          </md-button>
          <md-button class="md-raised md-dense md-primary"  v-on:click="$store.state.currentTransaction = JSON.parse(JSON.stringify(item)); $store.dispatch('setActiveTab', 'transactionDetails')">
            Detalji
          </md-button>
        </md-table-cell>
      </md-table-row>
    </md-table>

    <md-dialog-confirm :md-active="cancelDialog"
                md-title="Storno transakcije"
                md-content="<div id=stornoConfirm class='md-field md-theme-default md-focused md-required'><label for='stornoInfo'>Razlog</label><textarea id='stornoInfo' class='md-input stornoInput'></textarea><br><span class='md-error'>Ovo polje je obavezno</span></div>Jeste li sigurni?"
                md-confirm-text="Potvrdi"
                md-cancel-text="Zatvori"
                v-on:md-confirm="cancelTransaction"
                v-on:md-cancel="cancelDialog=false"
                >
    </md-dialog-confirm>
  </div>
</template>

<script>
import PaymentType from '../../mixins/payment-type.js'
import FormatCurrency from '../../mixins/format-currency.js'
import { mapGetters } from 'vuex';

export default {
  name: 'coupons',
  data(){
    return {
      filter: [],
      filteredTransactions: [],
      cancelDialog: false,
      stornoInfo: '',
    }
  },

  computed:{
    ...mapGetters([
      'getFilteredTransactions',
      'isPageLoaded'
    ])
  },

  mixins: [PaymentType('fromBill'), FormatCurrency],

  methods:{
    getPaymentType(paymentType){
      if(paymentType == 'cash') return 'Gotovina';
      else if(paymentType == 'virman') return 'Virman';
      else if(paymentType == 'coupon') return 'Darovni bon';
      else return 'Kartica'
    },

    cancelTransaction(){
      this.stornoInfo = document.getElementById('stornoInfo').value;
      if(this.stornoInfo == ""){
        document.getElementById("stornoConfirm").classList.add('md-invalid');
        return;
      }
      this.cancelDialog = false;
      this.$store.dispatch('cancelTransaction', {status: 'cancelled', list: 'transactionsCoupon', stornoInfo: this.stornoInfo});
    },

    isCancelDisabled(item){
      return item.data.is_cancelled || item.status == 'aborted' || item.status == 'cancelled' || item.status == 'expired'
    },
  },

  watch:{
    filter(val){
      this.filteredTransactions = this.getFilteredTransactions({searchKey: val, list: this.$store.state.receivedData.transactionsCoupon.list});
    },

    isPageLoaded(value){
      if(value) this.filter = ['online_sold', 'offline_sold'];
    }
  }
}
</script>

<style scoped lang="scss">
.stornoInput{
  resize: none;
  height: 150px!important;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/TransactionsCoupon.vue